import React, { Component } from 'react';
import Header from './Header/index';
import TopPicks from './Picks';
import Collections from './Collections';
import Media from './Media';
import Footer from './footer';
import ExperienceCard from './ExperienceCard';
import './Styles/new-york.css';

class Impressum extends Component {
  constructor() {
    super()
    this.state = {
      lat: 51.505,
      lng: -0.09,
      zoom: 13
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {

    return (
      <>
<div className="city-section-wrapper static-padding"><br />
    <h2
      style={{
        textAlign: 'left', marginBottom: 8
      }}
    >
      Impressum
    </h2>
    <hr
      style={{
        backgroundColor: '#355fb3',
        width: '75px',
        height: '2px',
        border: 'none',
        marginTop: '0px',
        marginLeft: '0px',
        marginBottom: '10px'
      }}
    />
    <div
      style={{
        color: '#545454',
        fontSize: '15.3px',
        marginTop: '0px',
        textAlign: 'left',
        lineHeight: '20px'
      }}
    >
      <p className="c1">
        <span className="c6">
          Dieses Impressum gilt für alle Angebote unter der Domain{" "}
        </span>
        <span className="c9 c6">
          <a
            className="c5"
            href="https://pmp-online.net"
          >
            https://pmp-online.net
          </a>
        </span>
        <span className="c0"> inklusive aller Subdomains (Unterseiten).</span>
      </p>
      <p className="c1">
        <span className="c7">Alle Angaben gemäß §5 TMG</span>
      </p>
      <p className="c1">
        <span className="c0"><b>PMPonline GmbH</b></span>
      </p>
      <p className="c1">
        <span className="c0">vertreten durch die Geschäftsführung: Marco Feulner, Thorsten Prennig und Dietmar Aumann
 </span>
      </p>
      <p className="c1">
        <span className="c0">Radolfstrasse 18</span>
      </p>
      <p className="c1">
        <span className="c0">96179 Rattelsdorf</span>
      </p>
      <p className="c1">
        <span className="c0">Telefon: +49 176 45869050</span>
      </p>
      <p className="c1">
        <span className="c6">E-Mail: </span>
        <span className="c6 c9">
          <a className="c5" href="mailto:info@pmp-online.net">
            info@pmp-online.net
          </a>
        </span>
      </p>
      <hr />
        <h4>Eintragungen</h4>
      <p className="c1">
        <span className="c0">
          Register: Handelsregister
        </span>
      </p>
      <p className="c1">
        <span className="c6">
          Registernummer: HRB 11959
        </span>

      </p>

      <p style={{ }} className="c1">
        <span className="c7">Steuernummer: 207/135/20021</span>
      </p>
      <p style={{ }} className="c1">
        <span className="c7">Umsatzsteuer-Identifikationsnummer: beantragt – wird nachgereicht</span>
      </p>
      <p className="c1">
        <span className="c6">Sparkasse Bamberg</span>
      </p>


      <p className="c1">
        <span className="c6">
                             IBAN: DE13770500000300743002</span>
      </p>
      <p className="c1 c8">
        <span className="c7" />
      </p>
      <hr />
      <p className="c1">
        <span className="c7"><b>Datenschutz</b></span>
      </p>
      <p className="c1">
        <span className="c6">
          Der Schutz Ihrer persönlichen Daten ist uns wichtig. Informationen zur Erhebung und Verwendung personenbezogener Daten auf dieser Website finden Sie in unserer

          <a
                      className="c5"
                      style={{paddingLeft: "4px"}}
                      href="https://pmp-online.net/datenschutz"
                    >
                      Datenschutzerklärung
                    </a>
          .
        </span>
      </p>
      <hr />
      <p className="c1">
        <span className="c7"><b>Haftung für Inhalte</b></span>
      </p>
      <p className="c1">
        <span className="c6">
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf
          diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach § 8 bis §
          10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
          übermittelte oder gespeicherte fremde Informationen zu überwachen oder
          nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
          hinweisen.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen
          nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
          diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
          konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
          Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </span>
      </p>
      <p className="c1 c8">
        <span className="c7" />
      </p>
      <p className="c1">
        <span className="c7"><b>Haftung für Links</b></span>
      </p>
      <p className="c1">
        <span className="c0">
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
          Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
          Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
          verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung
          auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
          Zeitpunkt der Verlinkung nicht erkennbar.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
          ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
          entfernen.
        </span>
      </p>
      <p className="c1">
        <h4>Urheberrecht</h4>
      </p>
      <p className="c1">
        <span className="c0">
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
          des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
          Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
          privaten, nicht kommerziellen Gebrauch gestattet.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
          werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
          Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
          Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
          entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
          wir derartige Inhalte umgehend entfernen.
        </span>
      </p>
      <p className="c1">
        <h4>Widerspruch gegen Werbe-E-Mails</h4>
      </p>
      <p className="c1">
        <span className="c0">
          Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
          Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung
          und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der
          Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der
          unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails,
          vor.
        </span>
      </p>


    </div>
    <div className="travel-card-wrapper">

    </div>
  </div>

      </>
    );
  }
}

export default Impressum;
